import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RowDefinition, DropDownItem, Translation, FieldDefinition } from '../driver-import-interfaces';
import { TranslateService } from '@ngx-translate/core';
import { DateFields, NameFields } from '../attr-mapping.constants';

@Component({
  selector: 'vrm-field-mapping-table',
  templateUrl: './mapping-table.component.html',
  styleUrls: ['./mapping-table.component.scss'],
})
export class MappingTableComponent {
  @Input() rows: RowDefinition[] = [];
  @Input() displayedColumns: string[] = ['originColumn', 'destinationColumn', 'delete'];
  @Input() dropDownItemsOrigin: DropDownItem[] = [];
  @Input() dropDownItemsDestination: DropDownItem[] = [];
  @Input() columnDefs: FieldDefinition[];

  @Output() rowUpdated = new EventEmitter<RowDefinition>();
  @Output() rowDeleted = new EventEmitter<RowDefinition>();
  @Output() newRowAdded = new EventEmitter<void>();
  @Output() newColumnAdded = new EventEmitter<void>();
  translation: Translation;
  constructor(private translate: TranslateService) {
    this.translate.get(['DRIVER_IMPORT']).subscribe({
      next: (translation) => {
        this.translation = translation.DRIVER_IMPORT;
      },
    });
  }
  onRowUpdate(row: RowDefinition) {
    this.rowUpdated.emit(row);
  }

  onDeleteRow(row: RowDefinition) {
    this.rowDeleted.emit(row);
  }

  onAddNewRow() {
    this.newRowAdded.emit();
  }

  onAddNewColumn() {
    this.newColumnAdded.emit();
  }

  formatOptions(fieldKey: string): string[] | null {
    let def = this.columnDefs.find((d) => d.fieldKey === fieldKey);
    return def ? def.formatOptions : null;
  }

  checkDateField(fieldName: string): boolean {
    return DateFields.includes(fieldName);
  }
  checkNameField(fieldName: string): boolean {
    return NameFields.includes(fieldName);
  }
}
